/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { MATOMO_TAG_MANAGER_CONTAINER_URL } from '@/containers/AnalyticsContainer/MatomoContainer/matomoContainer.utils';

declare global {
  interface Window {
    _mtm?: any[];
    _paq?: any[];
  }
}

export const useMatomo = () => {
  useEffect(() => {
    if (MATOMO_TAG_MANAGER_CONTAINER_URL) {
      const _mtm = (window._mtm = window._mtm || []);
      _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });
      const d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = MATOMO_TAG_MANAGER_CONTAINER_URL;
      if (s && s.parentNode) {
        s.parentNode.insertBefore(g, s);
      }
    }
  }, []);
};
